import { watch } from 'vue'
import { useConsentStore } from '~~/stores/consentStore'
import { useEdroneTracking } from '~~/app/composables/useEdroneTracking'
import { useMetaTracking } from '~~/app/composables/useMetaTracking'

/**
 * Re-aplikuje zapisaną zgodę przy KAŻDYM ładowaniu klienta — niezależnie od banera.
 * Powracający użytkownik nie renderuje banera, ale jego zgoda musi trafić do gtag,
 * najlepiej w oknie `wait_for_update: 500` (nuxt.config), aby pierwszy page_view
 * niósł pełną zgodę.
 */
export default defineNuxtPlugin(() => {
  const consent = useConsentStore()
  if (consent.hasDecided) {
    consent.applyConsent(consent.current)
  }

  // edrone SDK ładowany jest leniwie dopiero przy pierwszym zdarzeniu trackingu
  // (product/category view, add_to_cart, order, subscribe), a te padają zwykle
  // dopiero po nawigacji. Efekt: po kliknięciu „Akceptuję" na bieżącej stronie
  // skrypt edrone nie startował aż do przeładowania/przejścia (np. home → produkt).
  // Bootstrapujemy więc SDK reaktywnie w chwili, gdy zgoda marketingowa jest lub
  // staje się udzielona — analogicznie do natychmiastowego gtag consent update.
  // immediate:true pokrywa powracającego usera (SDK ładuje się już na 1. stronie),
  // a reakcja na zmianę pokrywa kliknięcie w baner bez potrzeby reloadu.
  const { bootstrap } = useEdroneTracking()
  const meta = useMetaTracking()
  watch(
    () => consent.current.marketing,
    (granted) => {
      if (granted) {
        bootstrap()
        // Odtwórz eventy Meta zbuforowane, gdy zgody jeszcze nie było (np. AddToCart
        // klikany przed akceptacją cookies, InitiateCheckout na wejściu do koszyka).
        meta.flushPending()
      }
    },
    { immediate: true },
  )

  // Odrzucenie zgody marketingowej — wyczyść bufor Meta (nic nie wysyłamy, respektuj wybór).
  watch(
    () => consent.hasDecided && !consent.current.marketing,
    (rejected) => { if (rejected) meta.clearPending() },
    { immediate: true },
  )
})
